<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <div v-else>

        <div class="container-title">

            <b-container>

                <b-row class="m-0 title-audit-text">
                    <b-col class="p-0 v-center">
                        {{entity.Name}}    
                    </b-col>

                    <b-col cols="1" 
                           class="p-0 h-end fs-17" 
                           @click="showCommentModal">

                        <div class="wrapper-circle-icon pointer">
                            <font-awesome-icon icon="comment-alt"/>
                        </div>
                    </b-col>                          
                </b-row>  
                
            </b-container>

        </div>

        <b-container class="m-20-auto">

            <b-list-group class="group-audit">

                <b-list-group-item >
                    <b-row class="m-0 row-activity">
                        <span class="activity-type">
                            Активность:
                        </span>

                        <span class="p-0 activity-name">
                            {{entity.TemplateName}}
                        </span>
                    </b-row>
                </b-list-group-item>

                <b-list-group-item v-for="(item, index) in entity.FormList"
                                   :key="index"
                                   class="pointer" 
                                   @click="selectForm(item)">

                    <form-item :index="index"
                               :item="item"
                               :is-ongoing="entity.IsOngoing"
                               :load="load"/>      

                </b-list-group-item>

                <b-list-group-item v-if="(entity.IsOngoing && entity.IsCanBeCompleted) || 
                                         (entity.IsCompleted && entity.IsCanBeCompleted)" 
                                   class="container-button">

                    <b-button v-if="entity.IsOngoing && entity.IsCanBeCompleted"
                              variant="outline-primary" 
                              class="button-blue"
                              @click="completeAudit">

                        <font-awesome-icon icon="check"/>
                        Завершить
                    </b-button>

                    <b-button v-if="entity.IsCompleted && entity.IsCanBeCompleted"
                              variant="outline-primary" 
                              class="button-blue"
                              @click="sendAudit">

                        <font-awesome-icon icon="check"/>
                        Отправить
                    </b-button>

                </b-list-group-item>

            </b-list-group>

            <b-img v-if="!entity.IsCompleted"
                   src="/img/btn-plus.png" 
                   class="button-plus"
                   @click="addTradePoint"/>

            <input-modal v-model="entity.Comment"
                         :is-edit="entity.Status.Id == 1" 
                         placeholder="Комментарий к аудиту"  
                         @save="updateComment"/>

        </b-container>

    </div>
    
</template>

<script>
import '@/assets/styles/client/audit/audit.css'

import AllRoutes from '@/routes/all.routes.js'
import apiService from '@/services/api.service'

import AuditModel from '@/store/models/client/audit/Audit'
import FormItem from '@/components/client/audit/FormItem'
import InputModal from '@/components/shared/InputModal'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

export default {
    data: function() {
        let load = new Loading();
        
        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id
                    : null;
        if(id)
            this.getAudit(load, id);

        return {
            load: load,
            entity: null,

            isFromForm: false
        }
    },
    beforeRouteEnter: function(to, from, next) {       
        next(vm => {
            vm.isFromForm = from.path == AllRoutes.Client.Form.Index;
        });
    },
    methods: {
        getAudit: function(load, id) {
            load.Calculate(true);

            apiService.Client.Audit.Get(id)
                .then(response => {

                    let isShortLine = response.data.Type == 2;

                    if(isShortLine) {
                        this.isFromForm 
                            ? this.$router.push(AllRoutes.Client.Feed)
                            : this.$router.push(AllRoutes.Client.Form.Index + `?id=${response.data.FormList[0].Id}&auditId=${this.$route.query.id}`);
                        return;
                    }

                    this.entity = new AuditModel().mapFromDto(response.data);                                    
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        showCommentModal: function() {
            this.$modal.show('input-modal');
        },

        selectForm: function(form) {
            this.$router.push(AllRoutes.Client.Form.Index + `?id=${form.Id}&auditId=${this.$route.query.id}`);
        },

        addTradePoint: function() {
            this.$router.push(AllRoutes.Client.TradePoints.Index + `?auditId=${this.entity.Id}`);
        },

        completeAudit: function() {
            this.load.Calculate(true);
            apiService.Client.Audit.PostComplete(this.entity.Id)
                .then(response => {
                    this.$router.go(this.$router.currentRoute);
                })
                .catch(error => this.load.Calculate(false));
        },

        sendAudit: function() {
            this.load.Calculate(true);
            apiService.Client.Audit.PostSend(this.entity.Id)
                .then(response => {
                    this.$router.push(AllRoutes.Client.Feed);
                })
                .catch(error => this.load.Calculate(false));
        },

        updateComment: function(text) {
            let comment = {Id: this.entity.Id, Comment: text };
            this.load.Calculate(true);
            
            apiService.Client.Audit.PostUpdateComment(comment)
                .then(response => {
                    this.$router.go(this.$router.currentRoute);
                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        FormItem,
        InputModal
    }
}
</script>